import CategoryTree from './CategoryTree'

export default CategoryTree
